<!--
@Description: 直播趋势页面
@Author: 吳廣帥
@Date:2022/1/5 - 10:14
@Name:liveTrend
@Version:v1.0
-->
<style scoped lang="less">
.not-monitored {
  text-align: center;
  padding: 1.5rem 0.75rem 1rem;

  .title {
    color: #4a4a4a;
    margin-bottom: 0.3rem;
  }

  .description {
    color: #a1aebf;
    line-height: 0.48rem;
    margin-bottom: 0.56rem;
  }

  .btn {
    width: 3rem;
    height: 1rem;
    border-radius: 0.08rem;
    margin: 0 auto;
    background: linear-gradient(180deg, #ffc900 0%, #ff9900 100%);
    font-size: 0.36rem;
    line-height: 1rem;
    color: white;
  }
}
/** 最外层div盒子*/
.liveTrend-box {
  background: #ffffff;
  &__control{

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &__check-box{
      width: 4rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4A4A4A;
      line-height: 0.28rem;
    }
  }
  &__banner{
    margin: 0 auto;
    border-radius: 0.08rem;
    width: 6.86rem;
    height: 0.76rem;
    background: #fff5ef;
    line-height: 0.76rem;
    text-align: center;
    font-size: 0.28rem;
    font-weight: 400;
    color: #4A4A4A;
    &__important{
      font-weight: 500;
      color: #ff5500;
    }
  }
}
</style>
<style lang="less">
/** 最外层div盒子 用于覆盖样式使用*/
.liveTrend-box {
}
</style>
<template>
  <div v-if="notMonitored" class="not-monitored">
    <div class="title">该直播暂未被监控</div>
    <div class="description">添加直播监控后，系统会立即跟踪该达人直播和带货数据</div>
    <div class="btn" @click="$emit('monitor')">添加监控</div>
  </div>
  <!--  组件最外层盒子-->
  <div class="liveTrend-box" v-else>
    <!--  控制区域  -->
    <div class="liveTrend-box__control">
      <DateSwitch :choose-options="[{label: '近7天',timeMode: 'nearWeek'},{label: '近30天',timeMode: 'nearMonth'}]" @switchTime="switchTime" :is-time-mode="false" @disabled="disabled" :disabled="!isVip"/>
      <van-checkbox v-model="onlyStream" shape="square" :disabled="!isVip" class="liveTrend-box__control__check-box" icon-size="14">只显示开播日期</van-checkbox>
    </div>
    <!--  顶部基础数据展示   -->
    <div class="liveTrend-box__banner">
      期间有 <span class="liveTrend-box__banner__important">{{ bannerData.days }}天</span> 开播，累计开播<span class="liveTrend-box__banner__important"> {{ bannerData.liveCount }}</span>，其中带货<span class="liveTrend-box__banner__important"> {{ bannerData.sellCount }}场</span>
    </div>
    <template v-if="bannerData.liveCount">
      <!--  开播趋势  -->
      <liveTrend :propData="liveTrendData"/>
      <!--  销售趋势  -->
      <salesTrend :propData="salesData"/>
      <template>
        <!--  人气趋势  -->
      <popularTrend :propData="popularData"/>
        <!--  互动趋势  -->
      <giftTrend :propData="popularData"/>
      </template>
    </template>
    <none-data :height="3.5" v-else class="chart" propsText="该主播在所选时间范围内无直播数据"/>
  </div>
</template>
<script>
import DateSwitch from '@/components/DateSwitchV2'
import liveTrend from './components/live'
import salesTrend from './components/sales'
import giftTrend from './components/gift'
import popularTrend from "./components/popular";
export default {
  /** 组件区 **/
  components: { DateSwitch, liveTrend, salesTrend, giftTrend, popularTrend },
  /** 方法区 **/
  methods: {
    /** 获取数据 **/
    async getTrendData(){
      this.$showLoading()
      const res = await this.$api.get(`/v1.1.0/gifshow/anchor/${this.$route.params.id}/liveStreamTrends`,{params: this.params }).catch( _ => ({}))
      this.apiData = res || {}
      setTimeout( _ => {
        this.$hideLoading()
      },1000)

    },
    /** 时间选择 **/
    switchTime(time){
      this.params.date = time
      this.getTrendData()
    },
    /** 禁用 **/
    disabled(){
      this.$store.commit('WRITEOVERLAYSHOW', {status: true, textChange: 'liveCalendar', yearVipOnly: {0: true,2: true}})
    },
  },
  computed: {
    isVip: (_this = this) =>  _this.$store.state.userLevel && _this.$store.state.userLevel <= 96 ,
    /** 监控状态 */
    notMonitored: (_this = this) => false,
    bannerData: (_this = this) => ({
      days: isNaN(_this.apiData.daysCount) ? '-' : _this.apiData.daysCount,
      liveCount: isNaN(_this.apiData.liveStreamCount) ? '-' : _this.apiData.liveStreamCount,
      sellCount: isNaN(_this.apiData.salesCount) ? '-' :  _this.apiData.salesCount
    }),
    parseData: (_this = this) => _this.onlyStream ? _this.apiData?.data.filter( ele => Object.keys(ele.trend).length ) : _this.apiData?.data || [], // 过滤是否存在开播
    liveTrendData : ( _this = this) => ({
      x: _this.parseData.map( ele => ele.date ),
      y: _this.parseData.map( ele => ele.trend.liveTrend || {})
    }),
    salesData : ( _this = this) => ({
      x: _this.parseData.map( ele => ele.date ),
      y: _this.parseData.map( ele => ele.trend.salesTrend || {})
    }),
    giftData : ( _this = this) => ({
      x: _this.parseData.map( ele => ele.date ),
      y: _this.parseData.map( ele => ele.trend.giftTrend || {})
    }),
    popularData : (_this = this) => ({
      x: _this.parseData.map( ele => ele.date ),
      y: _this.parseData.map( ele => ele.trend.pupularityTrend || {})
    })
  },
  data() {
    return {
      onlyStream:false,
      params:{ date:null },
      apiData:{},
    }
  },
}
</script>








